"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var constants_1 = require("../../constants");
var Check_1 = __importDefault(require("@greatmindsorg/gmui-icons-lib/dist/Check"));
var Cross_1 = __importDefault(require("@greatmindsorg/gmui-icons-lib/dist/Cross"));
var getStatusIcon_styled_1 = require("./getStatusIcon.styled");
var getStatusIcon = function (status, statusLabel) {
    var iconComponent = null;
    if (status.includes(constants_1.OPTION_LABEL.CORRECT) || status.includes(constants_1.OPTION_LABEL.CORRECT_NOT_SELECTED)) {
        iconComponent = (0, jsx_runtime_1.jsx)(Check_1.default, { iconSize: "s", title: statusLabel });
    }
    else if (status.includes(constants_1.OPTION_LABEL.INCORRECT)) {
        iconComponent = (0, jsx_runtime_1.jsx)(Cross_1.default, { iconSize: "s", title: statusLabel });
    }
    if (!iconComponent)
        return null;
    return (0, jsx_runtime_1.jsx)(getStatusIcon_styled_1.StyledIcon, { status: status, children: iconComponent });
};
exports.getStatusIcon = getStatusIcon;
